var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ visibility: _vm.viewMapInfo.showMap }),attrs:{"id":"viewMap"}},[_c('div',{staticClass:"map-container"},[_c('div',{staticStyle:{"width":"1200px","height":"400px","background-color":"antiquewhite"},attrs:{"id":"qqmapcontainer"}}),_c('i',{staticClass:"el-icon-close close-icon",on:{"click":_vm.closeMap}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }